import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/deployment/bundle-wallets.md?raw';

const DeploymentBundleWallets: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default DeploymentBundleWallets;
